module.exports = __webpack_public_path__ + "static/media/noPic_post.0c636deb.jpg";